import { useEffect, useState } from 'react';
import { useAppDispatch } from './redux';
import { getMasterFormatAction } from '../redux/actions/transparencyCatalogActions';
import { MasterFormatNode } from '../models/masterFormat/types';

// Shared across components so the tree is requested once per page load.
let masterFormatRequest: Promise<MasterFormatNode[] | null> | null = null;

// Returns null until the tree loads (or if it can't be loaded); callers then fall back to code-based shortening.
export const useMasterFormatTree = (): MasterFormatNode[] | null => {
    const dispatch = useAppDispatch();
    const [tree, setTree] = useState<MasterFormatNode[] | null>(null);

    useEffect(() => {
        let isCurrent = true;
        if (!masterFormatRequest) {
            masterFormatRequest = dispatch(getMasterFormatAction())
                .then((result) =>
                    getMasterFormatAction.fulfilled.match(result) && result.payload?.data?.length
                        ? result.payload.data
                        : null,
                )
                .catch(() => null);
        }
        masterFormatRequest.then((loaded) => {
            if (isCurrent) {
                setTree(loaded);
            }
            // Don't cache a failure for the whole session.
            if (!loaded) {
                masterFormatRequest = null;
            }
        });
        return () => {
            isCurrent = false;
        };
    }, [dispatch]);

    return tree;
};
